import React, { useState } from "react";
import { Container, Form, Button, Alert, Spinner } from "react-bootstrap";

function ContactUs() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    setStatusMessage("");

    try {
      const response = await fetch("https://www.og-services.co.za/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, message }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setStatus("success");
        setStatusMessage("Thanks! Your message has been sent.");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setStatus("error");
        setStatusMessage(
          data.message || "Something went wrong. Please try again later."
        );
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
      setStatusMessage("Network error. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Container fluid className="limited-width bg ogs-pri-text text-center py-5 mb-5">
        <h1 className="ogs-sec-text">Contact Us</h1>
      </Container>

      <Container fluid className="limited-width bg ogs-sec-text text-center py-5 mb-5">
        <p className="ogs-pri-text">
          Have a project in mind, or just exploring options? Share a few details
          below and we’ll get back to you with next steps.
        </p>

        {status && (
          <Alert variant={status === "success" ? "success" : "danger"} className="text-start">
            {statusMessage}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formName" className="mb-3 text-start">
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" placeholder="Enter your name" value={name} onChange={(e) => setName(e.target.value)} required />
          </Form.Group>

          <Form.Group controlId="formEmail" className="mb-3 text-start">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </Form.Group>

          <Form.Group controlId="formMessage" className="mb-3 text-start">
            <Form.Label>Message</Form.Label>
            <Form.Control as="textarea" rows={4} placeholder="Write your message here" value={message} onChange={(e) => setMessage(e.target.value)} required />
          </Form.Group>

          <Button variant="primary" type="submit" disabled={submitting}>
            {submitting ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                Sending...
              </>
            ) : (
              "Send"
            )}
          </Button>
        </Form>
      </Container>
    </div>
  );
}

export default ContactUs;